export const getCookie: (cookieName: string) => string | undefined = cookieName => {
    return document.cookie
        .split(';')
        .map(cookie => cookie.trim().split('='))
        .find(cookie => cookie?.[0] === cookieName)?.[1];
};

export const saveCookie: (cookieName: string, cookieValue: string, maxAge?: number, sameSite?: string, path?: string) => void = (cookieName, cookieValue, maxAge = 2592000, sameSite = 'Strict', path = '/') => {
    document.cookie = `${cookieName}=${cookieValue};Max-Age=${maxAge};SameSite=${sameSite};Path=${path}`;
};

export const deleteCookie: (cookieName: string, path?: string) => void = (cookieName, path = '/') => {
    document.cookie = `${cookieName}=; Path=${path}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};